 
<div
  [ngClass]="{
    'ui-rtl': cls.currentDirection() === 'rtl',
    'ui-ltr': cls.currentDirection() === 'ltr'
  }"
  [dir]="cls.currentDirection()"
>

  <router-outlet />

  <p-confirmDialog>
    <ng-template #message let-message>
      <div class="w-96 flex gap-3 flex-row items-center my-3"   [dir]="cls.currentDirection()">
        <span style="color: var(--p-red-500)">
          <i [class]="message.icon"></i>
        </span>
        <span class="text-xl">
          {{ message.message }}
        </span>
      </div>
    </ng-template>
  </p-confirmDialog>
  <p-toast />
</div>
